export default __webpack_public_path__ + "static/media/feature-image1.3087fdec.png";